import BreedAPI from '@/app/apis/main/breeds/breeds-api.js';

export default {
	/**
	 * @returns {object} breed list
	 */
	async getBreeds() {
		return BreedAPI.getBreeds();
	},

	/**
	 * @returns {object} breed list
	 * @params {number} breedSizeId
	 */
	async getBreedsBySize(breedSizeId) {
		return BreedAPI.getBreedsBySize(breedSizeId);
	},

	/**
	 * @return {object} breeds info for general, health, exercise
	 */
	async getBreedInfo(breedId) {
		return BreedAPI.getBreedInfo(breedId);
	},

	/**
	 * @return {object} breed info for health alerts notification
	 */
	async getBreedInfoByID(infoId) {
		return BreedAPI.getBreedInfoByID(infoId);
	},
	
	/**
	 * @return {object} breeds list
	 * @params {queryParams} - Contains pagination
	 */
	async getBreedList(queryParams) {
		return BreedAPI.getBreedList(queryParams);
	},

	/**
	 * @params {object} breedDetails
	 * @params breedId
	 * */
	async updateStatusBreed(breedId, breedDetails) {
		return BreedAPI.updateStatusBreed(breedId, breedDetails);
	},

	/**
	 * @params {object} breedDetails
	 * */
	async saveBreed(breedDetails) {
		return BreedAPI.saveBreed(breedDetails);
	},

	/**
	 * @return {object} breeds details
	 */
	async getBreedById(breedId) {
		return BreedAPI.getBreedById(breedId);
	},

	/**
	 * @params {object} breedDetails
	 * */
	 async updateBreed(breedDetails) {
		return BreedAPI.updateBreed(breedDetails);
	},

	async deleteBreed(breedId) {
		return BreedAPI.deleteBreed(breedId);
	}
};